import request from "../utils/request";

// export function getFileList(orderId) {
//     return request({
//         url: `/files/list`,
//         method: 'get',
//         params: { orderId: orderId }
//     })
// }

export function taskCountMonth(userId) {
    return request({
        url: `/homeCount/taskCountMonth/${userId}`,
        method: 'get'
    })
}
export function taskCountLastMonth(userId) {
    return request({
        url: `/homeCount/taskCountLastMonth/${userId}`,
        method: 'get'
    })
}
export function taskCountYear(userId) {
    return request({
        url: `/homeCount/taskCountYear/${userId}`,
        method: 'get'
    })
}

export function taskCountByMonth(userId,month) {
    return request({
        url: `/homeCount/taskCountByMonth/${userId}`,
        method: 'post',
        params: { month: month }
    })
}

export function salarySameMonth(userId) {
    return request({
        url: `/salary/sameMonth/${userId}`,
        method: 'get'
    })
}

export function salaryLastMonth(userId) {
    return request({
        url: `/salary/lastMonth/${userId}`,
        method: 'get'
    })
}

export function barChart(userId) {
    return request({
        url: `/homeCount/getBarChart/${userId}`,
        method: 'get'
    })
}
